
const Footer = () =>{

    return <div style={{height: '80px'}}></div>
}

export default Footer